import { getWindow } from "src/utility/window";

/**
 * Path prefix of the embedded (iframed) donate flow pages, served only on
 * the dedicated embed host (see proxy.ts and docs/embed-donate.md).
 */
export const EMBED_PATH_PREFIX = "/embed/";

/**
 * Whether this page is the embedded (iframed) donate flow. For code paths
 * that run outside React (no DonateFormContext / EmbedModeContext at hand).
 */
export function isEmbedPage(): boolean {
  return !!getWindow()?.location.pathname.startsWith(EMBED_PATH_PREFIX);
}
